import React from "react";

const GradientBgColor = () => {

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "13px",
          background: "linear-gradient(90deg, #E53D2B 0%, #F98738 20%, #F9D549 40%, #FFFFFF 60%, #2BCCF2 80%, #2847D6 100%)"
        }}
      >
      </div>
    </>
  )
}

export default GradientBgColor
